import Grid from "@material-ui/core/Grid";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";

const styles = makeStyles((theme)=>({
    img: {
        width: 50,
        height: 50,
        marginBottom: 10
    },
    box: {
        maxWidth: "33.333333%",
        textAlign: "center"
    }
}))
const SingleValidPropositions = props => {
    const classes = styles()
    return <Grid key={props.key} item className='col-lg-6 text-center'>
        <Grid justifyContent={"center"}>
            <img className={classes.img} src={props.pic} alt={props.title}/>
            <Typography>{props.title}</Typography>
        </Grid>
    </Grid>
}
export default SingleValidPropositions